import React from "react";
import { usePageContent } from "customProviders/LocationProvider";
import { Typography } from "@RHCommerceDev/unstyled-ui-components";
import getAbsoluteUrl from "@RHCommerceDev/utils/getAbsoluteUrl";
import { useLocalization } from "@RHCommerceDev/hooks/useLocalization";
import { cn } from "utils/cn";
import { SHOPPING_CART } from "utils/constants";
import CartIcon from "@RHCommerceDev/icon-header-cart";
import { useCartProjectionAtomValue } from "@RHCommerceDev/hooks/atoms";
import {
  ITEMS_IN_CART,
} from "@RHCommerceDev/resources/rh-header.json";

const CartButton = () => {
  const locale = useLocalization();

  const cartProjection = useCartProjectionAtomValue();
  const quantity = cartProjection?.totalItemQuantity;

  const {
    pageContent: { getAemModel }
  } = usePageContent();
  const pageContent = getAemModel;

  return (
    <a
      href={getAbsoluteUrl("/checkout/shopping_cart.jsp", locale)}
      aria-label={pageContent?.globalHeader?.SHOPPING_CART ?? SHOPPING_CART}
      className="text-inherit no-underline"
      data-analytics-ctaname={`${quantity} ${pageContent.globalHeader?.ITEMS_IN_CART ??
        ITEMS_IN_CART
        }`}
    >
      <div
        className={cn(
          "flex items-center justify-center",
          "h-[22px] w-[22px] sm:h-[26px] sm:w-[26px]"
        )}
      >
        <div className="relative flex">
          <CartIcon className="h-[17px] w-[14.28px]" />

          {!!quantity && (
            <Typography
              variant="default"
              fontFamily="rhcRoman"
              fontWeight="normal"
              className="absolute left-full top-0 ml-0.5 text-[10px] leading-none tracking-[0.04em]"
            >
              {quantity}
            </Typography>
          )}
        </div>
      </div>
    </a>
  );
};

export default CartButton;
